// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"155":"e72d100c","175":"ea222d44","610":"66bbfa80"}[chunkId] + ".js";
};